import { t } from "i18next";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { AiOutlineDownload, AiOutlineMail } from "react-icons/ai";
import { BsTelephone } from "react-icons/bs";
import Slider from "react-slick";
import { getAboutDirector, getAboutExecutive } from "../../api/about";
import Container from "../../components/Container";
import ImageWithTooltip from "../../components/ImageWithTooltip";
import PageContainer from "../../components/PageContainer";
import PersonCard from "../../components/PersonCard";
import { useTranslation } from "react-i18next";

const bgImg = "/images/hero-image.jpeg";

const TABS = ["executives", "directors"];

const ExecutiveBoard = () => {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState(TABS[0]);

  const displayTabs = (
    <nav className="flex justify-center bg-white w-full dark:bg-gray-800">
      <div className="text-sm font-medium text-center text-gray-500">
        <ul className="flex flex-wrap gap-2 -mb-px">
          <li>
            <a
              onClick={() => setActiveTab(TABS[0])}
              className={`cursor-pointer inline-block p-4 border-b-2 rounded-t-lg ${
                activeTab === TABS[0]
                  ? "text-red-600 border-red-600 dark:text-red-500 dark:border-red-500"
                  : "border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
              }`}
            >
              {t("executiveBoards")}
            </a>
          </li>
          <li>
            <a
              onClick={() => setActiveTab(TABS[1])}
              className={`cursor-pointer inline-block p-4 border-b-2 rounded-t-lg ${
                activeTab === TABS[1]
                  ? "text-red-600 border-red-600 dark:text-red-500 dark:border-red-500"
                  : "border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
              }`}
            >
              {t("boardOfDirectors")}
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );

  return (
    <PageContainer bgImg={bgImg} title="ทำเนียบผู้บริหาร">
      <div className="bg-[#F9F9F9]">
        {displayTabs}
        <Container>
          {activeTab === "executives" && <ExecutivesSection />}
          {activeTab === "directors" && <DirectorsSection />}
        </Container>
      </div>
    </PageContainer>
  );
};

export default ExecutiveBoard;

const ExecutivesSection = () => {
  const sliderRef = useRef(null);
  const [rows, setRows] = useState([]);
  const [person, setPerson] = useState(null);

  const getData = useCallback(() => {
    getAboutExecutive()
      .then((res) => {
        console.log('res', res);
        setRows(res.people);
        setPerson(res.people[0]);
      })
      .catch((err) => console.log(err));
  }, [setRows, setPerson]);

  useEffect(() => {
    getData();
  }, [getData]);

  const goToSlide = (index) => {
    sliderRef.current.slickGoTo(index);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    variableWidth: true,
    arrows: false,
    // slidesToShow: 1,
    slidesToScroll: 1,
  };

  const displayInfo = (
    <div className="px-3">
      <h3 className="text-[var(--base-color)] font-semibold">
        <span className="block text-3xl">{person?.ntitle}</span>
        <span className="block text-5xl">{person?.name}</span>
      </h3>
      <div className="text-lg font-medium border-b border-dotted border-slate-700 py-4">
        <p>{person?.position}</p>
      </div>
      <div className="py-4">
        <a
          className="text-2xl text-[var(--black-color)] font-semibold"
          href={`tel:+${person?.telno}`}
        >
          <div className="flex items-center py-1">
            <BsTelephone className="text-slate-400 size-5" />
            <span class="ml-2 text-2xl text-[var(--black-color)] font-semibold">
              {person?.telno}
            </span>
          </div>
        </a>
        <a
          className="text-2xl text-[var(--black-color)] font-semibold"
          href={`mailto:${person?.email}`}
        >
          <div className="flex items-center py-1">
            <AiOutlineMail className="text-slate-400 size-5" />
            <span class="ml-2 text-xl text-[var(--black-color)] font-semibold">
              {person?.email}
            </span>
          </div>
        </a>
        {person?.link_url && (
          <a
            href={person.link_url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center rounded-md text-sm font-semibold text-[var(--base-color)] hover:opacity-90 text-underline"
          >
            <div className="flex items-center py-1">
              <AiOutlineDownload className="text-slate-400 size-5" />
              <span className="ml-2 text-xl font-semibold">
                {person.link_title}
              </span>
          </div>
          </a>
        )}
      </div>
    </div>
  );

  const displaySlide = (
    <div className="">
      {displayInfo}
      <Slider ref={sliderRef} {...settings}>
        {rows.map((item, index) => {
          return (
            <div
              className="cursor-pointer"
              onClick={() => {
                setPerson(item);

                goToSlide(index);
              }}
            >
              <ImageWithTooltip
                src={item.image && item.image.path || ''}
                alt={item.name ?? ''}
                className="mx-5 h-[200px] object-cover"
              />
            </div>
          );
        })}
      </Slider>
    </div>
  );

  return (
    <div>
      <div>
        <img
          src="/images/logo-color-brand.png"
          alt="logo"
          className="h-[100px] mx-auto mt-5"
        />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-end">
        <div className="flex items-center justify-center">
          {/* {displayInfo} */}
          <div>
            <ImageWithTooltip
              src={person?.image?.path}
              className=" w-[350px] h-[500px] object-contain"
              alt={person?.image?.altText}
            />
          </div>
        </div>

        {displaySlide}
      </div>
    </div>
  );
};

const DirectorsSection = () => {
  const [rows, setRows] = useState([]);

  const getData = useCallback(() => {
    getAboutDirector()
      .then((res) => {
        setRows(res.people);
      })
      .catch((err) => console.log(err));
  }, [setRows]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    // <div className="flex gap-2 flex-wrap min-h-[800px]">
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 min-h-[800px]">
      {rows.map((item) => {
        return (
          <PersonCard
            imageSrc={item.image.path}
            name={`${item.ntitle}${item.name}`}
            title={item.position}
            phone={item.telno}
            email={item.email}
          />
        );
      })}
    </div>
  );
};
